/* eslint-disable no-restricted-syntax */
function extractDeepestCategories(categoryData) {
  const deepestCategories = []

  function traverse(categories) {
    if (!Array.isArray(categories)) {
      return
    }

    for (const category of categories) {
      // If this category has no subcategories or empty subcategories array,
      // it's at the deepest level
      if (!category.subcategories || category.subcategories.length === 0) {
        deepestCategories.push({
          categoryID: category.categoryID,
          label: category.label,
          shortLabel: category.shortLabel,
          parentID: category.parentID,
        })
      } else {
        // Recursively traverse subcategories
        traverse(category.subcategories)
      }
    }
  }

  // Start traversal from the root subcategories
  if (categoryData.subcategories) {
    traverse(categoryData.subcategories)
  }

  return deepestCategories
}

// Main execution
export function categoryMapper(categoryData) {
  try {
    const deepestCategories = extractDeepestCategories(categoryData)
    return deepestCategories
  } catch (error) {
    return []
  }
}
